import React, { Fragment } from 'react';
import { Listbox as BaseListbox, Transition } from '@headlessui/react';
import { SelectorIcon, CheckIcon } from '@heroicons/react/outline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function Listbox(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options;
  return /*#__PURE__*/_jsx(BaseListbox, {
    value: value,
    onChange: onChange,
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative mt-1",
      children: [/*#__PURE__*/_jsxs(BaseListbox.Button, {
        className: "relative w-full cursor-default rounded-lg border border-gray-300 bg-white  py-2 pl-3 pr-10 text-left focus:outline-none focus-visible:border-gray-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-500 dark:bg-slate-500 dark:text-gray-200 sm:text-sm",
        children: [/*#__PURE__*/_jsx("span", {
          className: "block truncate",
          children: value
        }), /*#__PURE__*/_jsx("span", {
          className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
          children: /*#__PURE__*/_jsx(SelectorIcon, {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          })
        })]
      }), /*#__PURE__*/_jsx(Transition, {
        as: Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx(BaseListbox.Options, {
          className: "absolute z-50 mt-1 max-h-72 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-slate-500 sm:text-sm",
          children: options.map(function (status) {
            return /*#__PURE__*/_jsx(BaseListbox.Option, {
              className: function className(_ref2) {
                var active = _ref2.active;
                return "relative cursor-default select-none py-2 pl-10 pr-4 ".concat(active ? 'bg-amber-100 text-amber-900 dark:bg-slate-500 dark:text-gray-200 hover:dark:bg-slate-700 ' : 'text-gray-900 dark:bg-slate-500 dark:text-gray-200');
              },
              value: status,
              children: function children(_ref3) {
                var selected = _ref3.selected;
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "block truncate ".concat(selected ? 'font-medium' : 'font-normal'),
                    children: status
                  }), selected ? /*#__PURE__*/_jsx("span", {
                    className: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600",
                    children: /*#__PURE__*/_jsx(CheckIcon, {
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  }) : null]
                });
              }
            }, status.toString());
          })
        })
      })]
    })
  });
}

export default Listbox;